// Dynamic import is mandatory for Module Federation chunk splitting.
// Do NOT add any other imports to this file.
import("./bootstrap");
